import { render } from "./Package.vue?vue&type=template&id=0b6528f8&scoped=true"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"

import "./Package.vue?vue&type=style&index=0&id=0b6528f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6528f8"]])

export default __exports__